import {Component, ViewChild, AfterViewInit, NgModule} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { MatSnackBar} from '@angular/material/snack-bar';
import {HttpClient} from '@angular/common/http';


import { PurchaseService } from '../_services'


@Component({
  selector: 'app-backoffice',
  templateUrl: './backoffice.component.html',
  styleUrls: ['./backoffice.component.scss']
})
export class BackofficeComponent {
  facturaForm: FormGroup;
  submitted = false;

  events: string[] = [];
  opened: boolean;
  vista: any = "compras-index";
  form_compras: []
  purchase: any = {};


  /// tabla compras 
  displayedColumns: string[] = [
                                  'fecha_timbrado',
                                  'fecha_pago',
                                  'num_confirmacion_banco', 
                                  'monto_banco',
                                  'folio_serie',
                                  'razon_social', 
                                  'rfc_emisor', 
                                  'uso_cfdi', 
                                  'concepto',
                                  'medio_pago', 
                                  
                                  'monto_base',
                                  'monto_iva',
                                  'monto_total',
                                  'monto_retenido',
                                  
                                  
                                  
                                  
                                  
                                  
                                  
                                ];
  purchaseDatabase: PurchaseDatabase | null;
  data: PurchaseIssue[] = [];
  coins;

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  constructor(
        private formBuilder: FormBuilder,
        private purchaseService: PurchaseService,
        private snackBar: MatSnackBar,
        private _httpClient: HttpClient
    ) {
        // redirect to home if already logged in
    }

 

 	setView(la_vista) {
		this.vista = la_vista;
		console.log("la vista es " + this.vista);
	}

  // openSnackBar(message: string, action: string) {
     //   this._snackBar.open(message, action, {
       //   duration: 2000,
      //  });
     // }

  ngOnInit() {
    this.facturaForm = this.formBuilder.group({
      razon: ['', Validators.required],
      rfc_emisor: ['', Validators.required],
      concepto: ['', Validators.required],
      uso_cfdi: ['', Validators.required],
      folio_serie: ['', Validators.required],
      fecha_emision: ['', Validators.required],
      fecha_timbrado: ['', Validators.required],
      monto_base: ['', Validators.required],
      monto_iva: ['', Validators.required],
      monto_retenido: ['', Validators.required],
      monto_total: ['', Validators.required],
      monto_banco: ['', Validators.required],
      fecha_pago: ['', Validators.required],
      num_confirmacion_banco: ['', Validators.required],
      concepto_banco: ['', Validators.required],
      medio_pago: ['', Validators.required]
    });

     
  }

  onSubmit() {
    console.log("submitted el form")
    console.log(this.facturaForm.value.razon)
    // hacer un servicio e invocarlo
    
    this.purchase["fecha_pago"] = this.facturaForm.value.fecha_pago
    this.purchase["fecha_emision"] = this.facturaForm.value.fecha_emision
    this.purchase["fecha_timbrado"] = this.facturaForm.value.fecha_timbrado
    this.purchase["tipo_comprobante"] = "factura_compra"
    this.purchase["concepto"] = this.facturaForm.value.concepto
    this.purchase["monto_base"] = this.facturaForm.value.monto_base
    this.purchase["monto_iva"] = this.facturaForm.value.monto_iva
    this.purchase["monto_total"] = this.facturaForm.value.monto_total
    this.purchase["monto_retenido"] = this.facturaForm.value.monto_retenido
    this.purchase["monto_banco"] = this.facturaForm.value.monto_banco
    this.purchase["folio_serie"] = this.facturaForm.value.folio_serie
    this.purchase["num_confirmacion_banco"] = this.facturaForm.value.num_confirmacion_banco
    this.purchase["medio_pago"] = this.facturaForm.value.medio_pago
    this.purchase["uso_cfdi"] = this.facturaForm.value.uso_cfdi
    this.purchase["razon_social"] = this.facturaForm.value.razon
    this.purchase["rfc_emisor"] = this.facturaForm.value.rfc_emisor


    this.purchase["concepto_banco"] = this.facturaForm.value.concepto_banco

    console.log("la purchase es ")
    console.log(this.purchase)
     this.purchaseService.registrar(this.purchase)
            .pipe(first())
            .subscribe(
                data => {
                   //  this.router.navigate([this.returnUrl]);
                   console.log("guardado recibido en component")
                   console.log("la data es")
                   console.log(data)
                   //this.openSnackBar("Compra guardada", "OK")
                   this.snackBar.open("Compra guardada", "OK", {                      
                      duration: 2000,
                    });
                   
                },
                error => {
                  //  this.error = error;
                    // this.loading = false;
                    console.log("error recibido en component")
                });
  }

  	
  ngAfterViewInit() {

    // this._hs.ffs_pendientes().subscribe(res => {
    //   this.coins = <any>res;
    //   this.la_fecha_corte = "el primer cambio";
    //   console.log("vamos con el resultado en ngAfterViewInit")
    //   console.log(this.coins);
    // } );

    

    this.purchaseDatabase = new PurchaseDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);


    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.purchaseDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          console.log("vamos en la 72")
          console.log(data)

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  


  }

  setClasses(fecha_creado) {
    let hoy = new Date();
    let fecha_pago = new Date(fecha_creado);

    let fecha_corte = new Date(this.coins);


   
    let myClasses = {
     // retrasado: Date.parse(fecha_corte.toISOString()) > Date.parse(fecha_creado),
     // a_tiempo: Date.parse(fecha_corte.toISOString()) < Date.parse(fecha_creado),
    }

    return  myClasses
  }


}

export interface PurchaseApi {
  items: PurchaseIssue[];
  total_count: number;
}

export interface PurchaseIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class PurchaseDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number): Observable<PurchaseApi> {
    console.log(sort)
    console.log(order)
    console.log(page)
    const href = 'https://vertigofin.herokuapp.com/query_purchases.json' + page;
    // const href = 'http://localhost:3000/query_sales.json' + page;
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}`;

    return this._httpClient.get<PurchaseApi>(requestUrl);
  }
}
